import styled from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import TextField from '@nubank/nuds-web/components/TextField/TextField';
import Button from '@nubank/nuds-web/components/Button/Button';
import Box from '@nubank/nuds-web/components/Box/Box';

export const StyledTypographyCTA = styled(Typography)`
  /* stylelint-disable property-no-vendor-prefix */
  background: ${props => (props.ctaGradient === 'default' ? props.color : props.ctaGradient)};
  color: ${props => (props.color)};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const StyledTextField = styled(TextField)`
  width: 100%;
  background-color: #F4F4F4;
  font-size: 14px;

  @media (width >= 768px) {
    font-size: 20px;
  }

  &::placeholder {
    color: #777;
  }

  &.red-error {
    &::placeholder {
      color: #D72923;
    }

    p {
      display: none;
    }
  }

  :invalid, :valid, :-webkit-autofill, :autofill {
    border:  none;
    border-radius: 6.25rem;
    height: 3rem;
    padding-left: 1rem;
    padding-right: 1.25rem;
  }

  :user-invalid {
    border: 2px solid #D72923;
  }
`;

export const StyledButton = styled(Button)`
  background-color: ${props => (props.buttonBackgroundColor)};
  position: absolute;
  right: 8px;
  top: 22px;
  height: 36px;
  width: 36px;

  svg {
    width: 24px;
    height: 24px;
  }
`;

// To hide default svg icon
export const StyledBox = styled(Box)`
  span {
    display: none;
  }

  p#error-email {
    margin-left: 12px;
    display: none;
  }
`;

export const CustomBox = styled(Box)`
  div {
    padding: 8px 0 0;
    min-height: auto;
  }
`;

export const StyledTypography = styled(Typography)`
  font-size: 16px;

  @media (width >= 768px) {
    font-size: 20px;
  }
`;

export const ErrorMessage = styled(Typography)`
  color: #D01D1C;
  font-size: 12px;
  font-weight: bold;
  margin-top: -6px;
  margin-left: 18px;
`;
